var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVariableData01 = function SvgVariableData01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "variable_data-01_svg2__a",
    x1: 55.64,
    x2: 229.57,
    y1: 208.27,
    y2: 36.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#variable_data-01_svg2__a",
    id: "variable_data-01_svg2__b",
    x1: -55.15,
    x2: 118.78,
    y1: 96.02,
    y2: -75.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#variable_data-01_svg2__a",
    id: "variable_data-01_svg2__c",
    x1: -5.8,
    x2: 168.13,
    y1: 146.02,
    y2: -25.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#variable_data-01_svg2__a",
    id: "variable_data-01_svg2__d",
    x1: 21.29,
    x2: 195.22,
    y1: 173.46,
    y2: 1.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#variable_data-01_svg2__a",
    id: "variable_data-01_svg2__e",
    x1: -31.27,
    x2: 142.66,
    y1: 120.21,
    y2: -51.46
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#variable_data-01_svg2__a",
    id: "variable_data-01_svg2__f",
    x1: 4.17,
    x2: 178.1,
    y1: 156.12,
    y2: -15.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#variable_data-01_svg2__a",
    id: "variable_data-01_svg2__g",
    x1: -12.51,
    x2: 161.42,
    y1: 139.22,
    y2: -32.46
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#variable_data-01_svg2__a",
    id: "variable_data-01_svg2__h",
    x1: 23.27,
    x2: 197.2,
    y1: 175.47,
    y2: 3.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#variable_data-01_svg2__a",
    id: "variable_data-01_svg2__i",
    x1: 45.03,
    x2: 218.96,
    y1: 197.51,
    y2: 25.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#variable_data-01_svg2__a",
    id: "variable_data-01_svg2__j",
    x1: 8.72,
    x2: 182.65,
    y1: 160.72,
    y2: -10.95
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#variable_data-01_svg2__a",
    id: "variable_data-01_svg2__k",
    x1: -40.63,
    x2: 133.3,
    y1: 110.73,
    y2: -60.94
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#variable_data-01_svg2__a",
    id: "variable_data-01_svg2__l",
    x1: -16.75,
    x2: 157.18,
    y1: 134.92,
    y2: -36.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#variable_data-01_svg2__a",
    id: "variable_data-01_svg2__m",
    x1: 32.59,
    x2: 206.52,
    y1: 184.91,
    y2: 13.24
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m145.63 132.1-.97 6.38c24.27 3.65 29.52 8.82 29.52 9.9s-5.2 6.19-29.03 9.83v-1.05c0-3.92-3.18-7.1-7.1-7.1-.3.02-.59-.16-.7-.45-.7-2.23-1.6-4.4-2.69-6.47a.73.73 0 0 1 .15-.83c2.77-2.78 2.78-7.27 0-10.05l-5.81-5.81c-2.75-2.76-7.22-2.78-10-.05-.23.21-.55.29-.85.21-2.08-1.09-4.26-2-6.5-2.7a.71.71 0 0 1-.45-.7c0-3.92-3.18-7.1-7.1-7.1h-8.26a7.13 7.13 0 0 0-7.1 7.15v.04c.02.24-.11.46-.32.56-2.28.7-4.48 1.61-6.59 2.73-.28.13-.61.07-.83-.15a7.36 7.36 0 0 0-10.06 0l-5.81 5.81c-2.76 2.75-2.78 7.22-.05 10 .2.23.28.55.22.85-1.09 2.08-2 4.26-2.7 6.5-.11.28-.39.46-.7.45-3.92 0-7.1 3.18-7.1 7.1v1.05c-23.82-3.63-29.02-8.74-29.02-9.82s5.25-6.26 29.51-9.9l-.97-6.38c-23.22 3.49-34.99 8.97-34.99 16.29v32.26c0 15.31 52.75 19.35 80.65 19.35s80.65-4.05 80.65-19.35v-32.26c0-7.32-11.78-12.8-35.01-16.29Zm-84.35 25.06c0-.36.29-.65.65-.65 3.13.03 5.91-1.99 6.85-4.97.59-1.87 1.35-3.68 2.26-5.41.53-1.01.81-2.13.8-3.26a7.44 7.44 0 0 0-2.11-5.12.646.646 0 0 1-.01-.91l.01-.01 5.81-5.81c.27-.25.7-.24.95.03a7.2 7.2 0 0 0 8.35 1.29c1.75-.93 3.59-1.69 5.48-2.28a7.06 7.06 0 0 0 4.89-6.84c0-.36.29-.65.65-.65h8.26c.36 0 .65.29.65.65a7.11 7.11 0 0 0 4.97 6.85c1.87.59 3.68 1.35 5.41 2.26 2.79 1.38 6.14.86 8.39-1.29.25-.25.66-.26.91-.01h.01l5.81 5.82c.12.12.18.29.18.46 0 .19-.08.36-.21.49a7.2 7.2 0 0 0-1.29 8.33 33.5 33.5 0 0 1 2.26 5.43 7.12 7.12 0 0 0 6.85 4.95c.36 0 .65.29.65.65v1.94c-4.13.51-8.45.94-12.95 1.27-.5-14.23-12.44-25.35-26.67-24.85-13.52.48-24.37 11.33-24.85 24.85-4.5-.32-8.83-.76-12.95-1.27v-1.93Zm58.04 3.61c-6.25.32-12.73.52-19.33.52s-13.08-.18-19.33-.52c.28-10.68 9.15-19.11 19.83-18.83 10.29.27 18.56 8.54 18.83 18.83m54.86 19.88c0 3.87-25.24 12.9-74.19 12.9s-74.19-9.03-74.19-12.9v-23.89c5.73 3.27 15.24 5.91 28.54 7.92.62.09 1.23.18 1.85.26l1.43.2c14.05 1.8 28.21 2.67 42.37 2.61 14.18.06 28.34-.81 42.4-2.62l1.4-.19c.62-.08 1.23-.17 1.84-.26 13.3-2 22.82-4.64 28.55-7.92z",
    style: {
      fill: "url(#variable_data-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.93 16.13C41.93 7.22 34.71 0 25.8 0S9.67 7.22 9.67 16.13s7.22 16.13 16.13 16.13c8.9-.01 16.12-7.23 16.13-16.13m-25.81 0c0-5.34 4.33-9.68 9.68-9.68s9.68 4.33 9.68 9.68-4.33 9.68-9.68 9.68-9.68-4.33-9.68-9.68",
    style: {
      fill: "url(#variable_data-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.89 32.26h25.81c1.78 0 3.23-1.44 3.23-3.23V3.23c0-1.78-1.44-3.23-3.23-3.23h-25.81c-1.78 0-3.23 1.44-3.23 3.23v25.81c0 1.78 1.44 3.23 3.23 3.23Zm3.23-25.81h19.35V25.8h-19.35z",
    style: {
      fill: "url(#variable_data-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.99 27.59-12.9-25.81a3.37 3.37 0 0 0-4.61-1.17c-.48.29-.88.69-1.17 1.17l-12.9 25.81a3.23 3.23 0 0 0 1.44 4.33c.44.22.93.34 1.43.34h25.81c1.78 0 3.23-1.43 3.24-3.21 0-.51-.11-1.01-.34-1.46m-23.49-1.78 7.68-15.37 7.68 15.37h-15.37Z",
    style: {
      fill: "url(#variable_data-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.94 30.65c.58 1 1.64 1.61 2.79 1.61h14.9c1.15 0 2.22-.61 2.79-1.61l7.45-12.9c.58-1 .58-2.23 0-3.23l-7.45-12.9A3.22 3.22 0 0 0 81.63.01h-14.9c-1.15 0-2.22.61-2.79 1.61l-7.45 12.9c-.58 1-.58 2.23 0 3.23zm4.66-24.2h11.17l5.59 9.68-5.59 9.68H68.6l-5.59-9.68z",
    style: {
      fill: "url(#variable_data-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.31 106.45V83.87c0-1.22-.69-2.34-1.78-2.89l-11.12-5.56V54.83h-6.45v22.58c0 1.22.69 2.34 1.78 2.89l11.12 5.56v20.59z",
    style: {
      fill: "url(#variable_data-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.28 116.13V100c0-1.22-.69-2.34-1.78-2.89L29.03 81.87V54.83h-6.45v29.03c0 1.22.69 2.34 1.78 2.89l30.47 15.24v14.14z",
    style: {
      fill: "url(#variable_data-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.12 85.86 11.12-5.54c1.1-.55 1.79-1.67 1.78-2.9V54.84h-6.45v20.59l-11.12 5.56a3.23 3.23 0 0 0-1.78 2.89v22.58h6.45V85.87Z",
    style: {
      fill: "url(#variable_data-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.96 81.88-30.47 15.24a3.23 3.23 0 0 0-1.78 2.89v16.13h6.45V102l30.47-15.22c1.1-.55 1.79-1.67 1.78-2.9V54.85h-6.45v27.04Z",
    style: {
      fill: "url(#variable_data-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.57 41.94h6.45v6.45h-6.45z",
    style: {
      fill: "url(#variable_data-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.57 41.94h6.45v6.45h-6.45z",
    style: {
      fill: "url(#variable_data-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.96 41.94h6.45v6.45h-6.45z",
    style: {
      fill: "url(#variable_data-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.96 41.94h6.45v6.45h-6.45z",
    style: {
      fill: "url(#variable_data-01_svg2__m)"
    }
  }));
};
export default SvgVariableData01;